import { IImportValidationError } from "./IImportValidation";

export interface IImportAdapterResult {
    preProcessedDataRows?: string[];
    originalRowCols?: IRowCol[][];
    errors?: IImportValidationError[]; 
    status?: ImportPreProcessResult;
}

export enum ImportPreProcessResult {
    Ok = 1,
    Error = 2
}

export interface IRowCol {
    row: number;
    colFrom: number;
}
